<template>
  <v-card
      class="mx-auto"
      max-width="344"
      @click="$emit('itemClicked', document)"
  >
    <pdf
        ref="pdf"
        v-if="document.fileType === 'application/pdf'"
        :src="src"
        class="pdf docu-preview"
        height="200px"
    />
    <div style="height: 136px;" v-else-if="document.fileType === 'image/jpeg' || document.fileType === 'image/png'">
      <v-img
          :src="src"
          contain
          height="200px"
      />
    </div>

    <v-card-subtitle>
      {{ document.note }}
    </v-card-subtitle>
  </v-card>
</template>
<script>
import DocumentationService from "@/modules/core/services/documentation-service";

export default {
  name: 'DocumentItem',
  props: {
    document: {}
  },
  components: {
    pdf: () => import('vue-pdf')
  },
  data: () => ({
    src: '',
    show: false
  }),
  methods: {
    loadStaticFile() {
      DocumentationService.getDocByTypeAndId(
          this.document.id,
          this.document.fileType,
          this.document.documentType,
          this.document.task,
          (fileUrl) => {
            this.src = fileUrl;
          },
          () => {
          }
      )
    }
  },
  mounted() {
    this.loadStaticFile();
  }
}
</script>